import { Transform, CSS } from '@dnd-kit/utilities';
import { styled } from '@innowise-group/mui-kit';

export const Wrapper = styled.div<{ isDragging: boolean; transform: Transform; transition: string }>`
  opacity: ${({ isDragging }) => (isDragging ? '0.4' : '1')};
  transform: ${({ transform }) => CSS.Translate.toString(transform)};
  transition: ${({ transition }) => transition};
`;
